import { useState } from "react";
import styled, { keyframes } from "styled-components";
import { Button } from "../typography/button.component";
import Tick from "../../assets/tick.jpg";
import Process from "../../assets/SpinnerGap.svg";
import CloseHamburgerMenu from "../../assets/CloseIcon.svg";
import { useTranslation } from "react-i18next";

/*for firebase config, remove after done with it*/
import { db } from "../../temporal/firebase";
import {
  collection,
  addDoc,
  setDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";

const ModalTitle = styled.div`
  font-weight: 700;
  font-style: bold;
  font-size: 30px;
  color: rgba(29, 109, 193, 1);
  display: flex;
  justify-content: center;
  text-align: center;
`;
const ModalContainer = styled.div.attrs({ className: "modal" })`
  position: fixed;
  max-width: 400px;
  max-height: 80%;
  overflow-y: auto;   /* enables vertical scrolling */
  overflow-x: hidden; /* prevents horizontal scroll */
  background-color: rgba(255, 252, 252, 1);
  z-index: 9999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 32px 48px 32px;
  border: 1px solid black;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  transition: all 600ms ease-in-out;
  z-index: 999999;
`;
const ModalPara = styled.div`
  && {
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: rgba(11, 11, 11, 1);
    text-align: center;
    margin-top: 12px;
    opacity: 1;
  }
`;
const ModalInfo = styled.form``;
const ModalInfoPara = styled.p`
  font-weight: 500;
  font-style: medium;
  font-size: 16px;
  color: rgba(11, 11, 11, 1);
  text-align: justify;
  margin-top: 18px;
`;
const ModalInput = styled.input`
  font-size: 20px;
  border-radius: 4px;
  padding: 6px 12px;
  outline: none;
  border: 1px solid lightgray;
`;
const ModalTextField = styled.textarea`
  font-size: 20px;
  border-radius: 4px;
  padding: 6px 12px;
  outline: none;
  max-width: 310px;
  max-height: 114px;
  border: 1px solid lightgray;
`;
const CloseModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  font-size: 32px;
  margin: 0;
`;
const Close = styled.figure`
  max-height: 42px;
  margin: 0;
  cursor: pointer;
  max-width: 42px;
`;
const ModalButtonWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
const Select = styled.select`
  font-size: 20px;
  border-radius: 4px;
  padding: 6px 12px;
  outline: none;
  border: 1px solid lightgray;
  width: 100%;
`;
const Success = styled.span`
  color: ${(props) => props.theme.colors.text.success};
  font-size: ${(props) => props.theme.fontSizes.caption};
  display: flex;
  align-items: center;
`;
const Image = styled.img`
  width: 100%;
  max-width: 16px;
  max-height: 16px;
  height: 100%;
  padding: 4px;
`;
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const ProcessImage = styled.img`
  width: 100%;
  max-width: 24px;
  max-height: 24px;
  font-weight: 700;
  height: 100%;
  animation: ${spin} 1s linear infinite;
`;
const CloseModal = styled.img`
  filter: invert(1);
  font-weight: 700;
  min-height: 100%;
  min-width: 100%;
`;

export const Modal = ({
  setModalOpen,
  isPartnerWithUs,
  setIsPartnerWithUs,
}) => {
  const [email, setEmail] = useState();
  const [comments, setComments] = useState();
  const [reason, setReason] = useState();
  const [phone, setPhone] = useState();
  const [name, setName] = useState();
  const [aboutYou, setAboutYou] = useState();
  const [role, setRole] = useState("patient");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [isProcessing, setIsprocessing] = useState(false);

  const { t } = useTranslation();

  const submit = async (e) => {
    e.preventDefault();
    setIsprocessing(true);
    setError("");

    let collection = isPartnerWithUs ? "partnership" : "waitlist";

    try {
      await setDoc(doc(db, collection, email), {
        email,
        name,
        role: isPartnerWithUs ? "partner" : role,
        comments: isPartnerWithUs ? comments : null,
        phone: isPartnerWithUs ? phone : null,
        reason: isPartnerWithUs ? reason : null,
        createdAt: serverTimestamp(),
      });

      setTimeout(() => {
        setModalOpen(false);
      }, 10000);
      setDone(true);
    } catch (err) {
      setError("Something went wrong.");
      console.error(err.code);
    }
    setIsprocessing(false);
  };

  return (
    <ModalContainer>
      <CloseModalWrapper>
        {done && (
          <Success>
            <Image src={Tick} />
            {isPartnerWithUs
              ? "Thank you for your interest, we will get back to you soon."
              : "Thank you for joining our waitlist, we'll notify you soon"}
          </Success>
        )}
        <Close
          onClick={() => {
            setModalOpen(false);
            setIsPartnerWithUs(false);
          }}
        >
          {" "}
          <CloseModal src={CloseHamburgerMenu} alt="exit" />{" "}
        </Close>
      </CloseModalWrapper>
      <ModalTitle>
        {isPartnerWithUs ? t('partnerModal.title') : t('waitlistModal.title')}
      </ModalTitle>
      <ModalPara>
        {isPartnerWithUs
          ? t('partnerModal.description')
          : t('waitlistModal.description')}
      </ModalPara>
      <ModalInfo onSubmit={submit}>
        <ModalInfoPara>
          {isPartnerWithUs
            ? t('partnerModal.enterDetails')
            : t('waitlistModal.chooseOption')}
        </ModalInfoPara>
        {isPartnerWithUs ? null : (
          <>
            <Select onChange={(e) => setRole(e.target.value)}>
              <option value={"patient"}>User</option>
              <option value={"health-personnel"}>I'm a health personnel</option>
            </Select>
          </>
        )}
        <ModalInfoPara>{t('waitlistModal.nameLabel')}: *</ModalInfoPara>
        <ModalInput
          placeholder={t('waitlistModal.namePlaceholder')}
          required
          type="text"
          maxLength={20}
          minLength={2}
          onChange={(e) => setName(e.target.value)}
        />
        <ModalInfoPara>{t('waitlistModal.emailLabel')}: *</ModalInfoPara>
        <ModalInput
          placeholder={t('waitlistModal.emailPlaceholder')}
          required
          maxLength={30}
          minLength={12}
          type="email"
          onChange={(e) => setEmail(e.target.value)}
        />

        {isPartnerWithUs && (
          <>
            <ModalInfoPara>{t('partnerModal.phoneLabel')}: *</ModalInfoPara>
            <ModalInput
              placeholder={t('partnerModal.phonePlaceholder')}
              required
              type="tel"
              onChange={(e) => setPhone(e.target.value)}
            />{" "}
          </>
        )}

        {isPartnerWithUs ? (
          <>
            <ModalInfoPara>{t('partnerModal.reasonLabel')}: *</ModalInfoPara>
            <ModalTextField
              placeholder={
                t('partnerModal.reasonPlaceholder')
              }
              required
              maxLength={100}
              minLength={10}
              type="text"
              onChange={(e) => setReason(e.target.value)}
            />{" "}
          </>
        ) : null}

        {isPartnerWithUs ? (
          <>
            <ModalInfoPara>{t('partnerModal.extraCommentsLabel')}:</ModalInfoPara>
            <ModalTextField
              placeholder={t('partnerModal.extraCommentsPlaceholder')}
              maxLength={100}
              type="text"
              onChange={(e) => setComments(e.target.value)}
            />{" "}
          </>
        ) : null}

        <ModalButtonWrapper>
          <Button>
            {isProcessing ? (
              <ProcessImage src={Process} />
            ) : isPartnerWithUs ? (
              t('partnerModal.submitButton')
            ) : (
              t('waitlistModal.submitButton')
            )}
          </Button>
        </ModalButtonWrapper>
      </ModalInfo>
    </ModalContainer>
  );
};
